export enum PermissionAction {
  VIEW = 'view',
  CREATE = 'create',
  UPDATE = 'update',
  DELETE = 'delete',
}

export enum PermissionSubject {
  WORK_ORDER = 'work_order',
  WO_PLANNED = 'wo_planned',
  WO_HISTORICAL = 'wo_historical',
  WO_ANALYTICS = 'wo_analytics',
  INCIDENT = 'incident',
  INCIDENT_HISTORICAL = 'incident_historical',
  INCIDENT_ANALYTICS = 'incident_analytics',
  MACHINE = 'machine',
  STATIONS_DASHBOARD = 'eff_stations_dashboard',
  STATION = 'eff_station',
  COMPANY_DASHBOARD = 'eff_summary_dashboard',
  FACTORY_GPT = 'factory_gpt',
  PROCESS_VARIABLES = 'eff_processes_variable_dashboard',
  PREDICTIONS = 'eff_prediction_dashboard',
  STATION_ASSIGN_STOP = 'eff_station_assign_stop',
  CONFIG_ACCOUNT_STATIONS = 'config_account_stations',
  CONFIG_ACCOUNT_USERS = 'config_account_users',
  CONFIG_ACCOUNT_PRODUCTS = 'config_account_products',
  CONFIG_ACCOUNT_MACHINES = 'config_account_machines',
  CONFIG_ACCOUNT_DOWNTIME_REASONS = 'config_account_downtime_reasons',
  CONFIG_ACCOUNT_QUALITY_REASONS = 'config_account_quality_reasons',
  CONFIG_ACCOUNT_BULK_DATA = 'config_account_bulk_data',
  CONFIG_GATEWAYS = 'config_gateways',
  CONFIG_METRICS = 'config_metrics',
  SCRAP = 'scrap',
  COST = 'cost',
}
